import React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import SignInScreen from '../screens/SignIn';
import SignUpScreen from '../screens/SignUp';
import TermsOfServiceScreen from '../screens/TermsOfService';
import ForgotPasswordScreen from '../screens/ForgotPassword';
import VerifyUserScreen from '../screens/VerifyUser';

const Stack = createStackNavigator();

const AuthNavigator = ({ isSignout }: { isSignout: Boolean }) => (
  <Stack.Navigator initialRouteName="SignIn" headerMode="none">
    <Stack.Screen
      name="SignIn"
      component={SignInScreen}
      options={{
        title: 'Sign in',
        animationTypeForReplace: isSignout ? 'pop' : 'push',
      }}
    />
    <Stack.Screen
      name="SignUp"
      component={SignUpScreen}
      options={{
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    />
    <Stack.Screen
      name="VerifyUser"
      component={VerifyUserScreen}
      options={{
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    />
    <Stack.Screen
      name="TermsOfService"
      component={TermsOfServiceScreen}
      options={{
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    />
    <Stack.Screen
      name="ForgotPassword"
      component={ForgotPasswordScreen}
      options={{
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    />
  </Stack.Navigator>
);

export default AuthNavigator;
